const indexItems = [
  { label: '刃牙道', count: '126话', desc: '最新连载篇章' },
  { label: '范马刃牙', count: '312话', desc: '正传完整收录' },
  { label: '刃牙II', count: '276话', desc: '第二部全篇' },
  { label: '刃牙', count: '371话', desc: '初代经典全集' },
  { label: '刃牙外传', count: '48话', desc: '番外合集' },
  { label: '烈海王异世界', count: '36话', desc: '热门外传' },
  { label: '花山薰外传', count: '24话', desc: '拳王传奇' },
  { label: '刃牙动画联动', count: '52期', desc: '动画漫画对比' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          主题索引
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          刃牙漫画全集分篇章导航，快速找到想看的章节
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-5 transition-all duration-300 hover:border-primary-200/60 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base md:text-lg font-heading text-foreground-950 group-hover:text-primary-500 transition-colors">{item.label}</h3>
                <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded-full whitespace-nowrap">{item.count}</span>
              </div>
              <p className="text-sm text-foreground-500">{item.desc}</p>
              <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                <span>立即阅读</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}